export const filter = (obj: any, condition: (arg: any) => boolean) =>
  obj &&
  Object.keys(obj).reduce<any>((prev, key) => {
    const value = obj[key]
    if (condition(value)) prev[key] = value
    return prev
  }, {})
export const filterUndefined = (obj: any) =>
  filter(obj, (arg: any) => arg !== undefined)

export const filterFalsy = (obj: any) => filter(obj, (arg: any) => !!arg)

export const propsAreEqual = <T>(prev: T, next: T) => {
  const prevKeys = Object.keys(prev)
  const nextKeys = Object.keys(next) as (keyof T)[]
  if (prevKeys.length !== nextKeys.length) return false
  if (new Set([...prevKeys, ...nextKeys]).size !== nextKeys.length) return false
  return !nextKeys.some((key) => prev[key] !== next[key])
}
